/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link } from '@ta-interaktiv/contentbricks'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import renderHTML from 'react-render-html'

const params = new URL(window.location.toString())

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      title: null,
      output: [],
      linkText: 'laden...',
      linkID: null,
      columnCount: 0,
      colorMode: false
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 600,
      isTablet: window.innerWidth < 900 && window.innerWidth > 599
    })

    /* GET SHEET DATA VIA CLOUD STORAGE */
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/embed-news-box/news.json'
    )
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error('Cloud Function Data was not OK')
        }
      })
      .then(responseData => {
        // console.log('responseData:', responseData)
        this.setState({ title: responseData[0].Titel })
        this.setState({ linkText: responseData[0].Linktext })
        this.setState({ linkID: responseData[0].Linkziel })
        const output = responseData.map(function(item, index) {
          // console.log('message', message)
          return <li key={index}>{renderHTML(item['Einträge'])}</li>
        })
        this.setState({ output: output, columnCount: responseData.length })
      })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()

    /* DETECT DARK MODE (USER SETTINGS ON WEBPAGE) */
    window.addEventListener('message', event => {
      if (
        [
          'https://www.tagesanzeiger.ch',
          'https://www.bernerzeitung.ch',
          'https://www.tdg.ch',
          'https://www.derbund.ch',
          'https://www.24heures.ch',
          'https://www.bazonline.ch',
          'https://www.landbote.ch',
          'https://www.thunertagblatt.ch',
          'https://www.berneroberlaender.ch',
          'https://www.langenthalertagblatt.ch',
          'https://www.zsz.ch',
          'https://www.landbote.ch',
          'https://www.zuonline.ch',
          'https://www.thunertagblatt.ch'
        ].indexOf(event.origin) !== -1
      ) {
        // this check is needed because of https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#security_concerns
        if (event.data.type === 'colorMode') {
          this.setState({ colorMode: event.data.mode }) // will be the string 'dark' or 'light'
        }
      }
    })
  }

  render() {
    return (
      <div
        className={
          'index ' +
          (!this.state.colorMode
            ? ''
            : this.state.colorMode === 'light'
            ? ' light'
            : ' dark')
        }
      >
        <div className='news-box'>
          <ThemeSwitch />
          <h2>{this.state.title}</h2>
          <ul
            style={{
              gridTemplateColumns: this.state.isMobile
                ? '1fr'
                : this.state.isTablet && this.state.columnCount > 2
                ? '1fr 1fr'
                : this.state.columnCount > 3
                ? '1fr 1fr 1fr 1fr'
                : this.state.columnCount > 2
                ? '1fr 1fr 1fr'
                : this.state.columnCount > 1
                ? '1fr 1fr'
                : '1fr 1fr'
            }}
          >
            {this.state.output}
          </ul>
          <Link
            className='linkbutton'
            href={
              'https://www.' +
              parseHostname().publicationDomain +
              '/' +
              this.state.linkID
            }
            target='_top'
            hideIcon
          >
            {this.state.linkText}
          </Link>
        </div>
      </div>
    )
  }
}
